import React, { useState } from "react";
import favouriteImg from "../../images/favorite.svg";
import facebookImg from "../../images/facebook.svg";
import linkedinImg from "../../images/linkedin.svg";
import instaImg from "../../images/instagram.svg";
import Logo from "../../images/logo.svg";
import { Link } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import { RiMenu2Fill } from "react-icons/ri";
import Login from "./Login";
import { emailID, UAENum } from "../../Const";
import { REMail, RETelephone } from "../../components/icons/IconSvg";

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);
    const [isAuth, setISAuth] = useState(null);
    const [show, setShow] = useState(false);

    const handleOpen = () => setShow(true);
    const handleClose = () => setShow(false);
    const toggleNavbar = () => setIsOpen(!isOpen);
    const toggleClose = () => setIsOpen(false);

    return (
        <>
            <header>
                <div className="header-sec">
                    <div className="container">
                        <div className="header-top-sec">
                            <div className="header-inner-sec">
                                <div className="header-info">
                                    {/* <img src={mailImg} alt="mail" /> */}
                                    <REMail/>
                                    <a href={`mailto:${emailID}`}>{emailID}</a>
                                </div>
                                <div className="header-info">
                                    {/* <img src={callImg} alt="call" /> */}
                                    <RETelephone/>
                                    <a href="tel:+97145534370">{UAENum}</a>
                                </div>
                            </div>
                            <div className="header-inner-sec">
                                <div className="header-info header-info-right">
                                    {isAuth ? (
                                        <Link to="/property/for-sale/favourite">
                                            <img src={favouriteImg} alt="favourite" className="me-2" />
                                            Favourite Properties
                                        </Link>
                                    ) : (
                                        <button onClick={handleOpen}>
                                            <img src={favouriteImg} alt="favourite" className="me-2" />
                                            <span>Favourite Properties</span>
                                        </button>
                                    )}
                                </div>
                                <div className="header-info-right">
                                    <span>Follow Us:</span>
                                    {/* <a href="https://www.facebook.com/nhgulf" target="_blank" rel="noreferrer">
                                        <img src={facebookImg} alt="facebook" />
                                    </a> */}
                                    <a href="/" rel="noreferrer">
                                        <img src={facebookImg} alt="facebook" />
                                    </a>
                                    {/* <a
                                        href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGlZhkzYcXuEgAAAZk4X7dIvoPW_vHlYcht9xYxWEf268g4rjrQCtCNa-kRxz2U64rrUTJf5o1TdNNV2BlRjWzTEIuB2XN64rOatH1Ri2ML1eyVP486McGiXRQxU2AOmMgDiAA=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fnhgulf%2F"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <img src={linkedinImg} alt="linkedin" />
                                    </a> */}
                                     <a
                                        href="/"
                                        rel="noreferrer"
                                    >
                                        <img src={linkedinImg} alt="linkedin" />
                                    </a>
                                    {/* <a href="https://www.instagram.com/nhreal.estate/#" target="_blank" rel="noreferrer">
                                        <img src={instaImg} alt="instagram" />
                                    </a> */}
                                    <a href="/" rel="noreferrer">
                                        <img src={instaImg} alt="instagram" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="navbar-info">
                    <div className="container">
                        <div className="navbar-link-info">
                            <div className="navbar-logo">
                                <Link to="/">
                                    <img src={Logo} alt="Lead Tracks" />
                                </Link>
                            </div>
                            <button className="menu-toggle-btn" onClick={toggleNavbar}>
                                {/* {isOpen ? "☰" : " ✖"} */}
                                <RiMenu2Fill />
                            </button>
                            {isOpen && <div className={`sidebar-overlay ${isOpen ? "active" : ""}`} onClick={toggleNavbar}></div>}
                            <div className={`navbar-info-inner ${isOpen ? "open" : "close"}`}>
                                <div className="navbar-links">
                                    <div className="sidebar-logo">
                                        <Link to="/">
                                            <img src={Logo} alt="Lead Tracks" />
                                        </Link>
                                        <div className="close-menu">
                                            <IoArrowBack onClick={toggleNavbar} />
                                        </div>
                                    </div>
                                    <ul>
                                        <li>
                                            <Link to="/about-us" onClick={toggleClose}>
                                                About Us
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/new-project" onClick={toggleClose}>
                                                Project
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/agents" onClick={toggleClose}>
                                                Find My Agent
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog" onClick={toggleClose}>
                                                Blog
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/news" onClick={toggleClose}>
                                                News and Artical
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/contact-us" onClick={toggleClose}>
                                                Contact Support
                                            </Link>
                                        </li>
                                        {/* <li>
                                            <Link to="/new-projects/dev-list" >
                                                Find Developers
                                            </Link>
                                        </li> */}
                                        {/* <li>
                                            <Link to="/new-projects/dev-list" >
                                                Find Developers
                                            </Link>
                                        </li> */}
                                        {/* <li>
                                            <Link to="/floor-plan" >
                                                Floor Plans
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/area-guides">Guides</Link>
                                        </li> */}
                                    </ul>
                                </div>
                                <div className="login-btn">
                                    <button className="button" onClick={handleOpen}>
                                        Login
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {show && <Login show={show} handleHide={handleClose} onShow={handleOpen} />}
        </>
    );
}
